<template>
  <a-card :bordered="false">
    <a-form layout="inline">
      <a-form-item>
        <a-input v-model="queryParams.itemId" placeholder="项目ID"></a-input>
      </a-form-item>
      <a-form-item>
        <a-input v-model="queryParams.itemName" placeholder="项目名称"></a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="$refs.tableList.refresh(true)">查询</a-button>
      </a-form-item>
      <a-form-item style="float: right;">
        <a-button type="primary" @click="addProject">添加项目</a-button>
      </a-form-item>
    </a-form>
    <custom-page-table
      style="margin-top: 16px;"
      ref="tableList"
      :queryParams="queryParams"
      :columns="columns"
      base-key="resourceUrl"
      query-path="item/get/merchantItemList"
    >
      <span slot="itemResourcesPurview" slot-scope="rowItem">
        {{ getResourcesPurviewStr(rowItem.record.itemResourcesPurview) }}
      </span>
      <span slot="itemStatus" slot-scope="rowItem">
        {{ rowItem.record.itemitemStatus == 1 ? '待加入' : '正常' }}
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editProjectEvent(rowItem.record)">编辑项目</a>
        <a style="margin-left: 20px;" @click="bindProductEvent(rowItem.record)">关联商品</a>
      </span>
    </custom-page-table>
    <a-modal :title="title" :footer="null" :visible="projectVisible" @cancel="handleAddCancel">
      <a-form-model :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol">
        <a-form-model-item label="项目名称">
          <a-input v-model="itemName" placeholder="请输入项目名称"></a-input>
        </a-form-model-item>
        <a-form-model-item label="被授权资源方">
          <a-input v-model="itemResourcesEmail" placeholder="请输入邮箱，仅能添加一个"></a-input>
        </a-form-model-item>
        <a-form-model-item label="授权权限">
          <a-checkbox-group v-model="checkList">
            <a-checkbox value="1">订单处理</a-checkbox>
            <a-checkbox value="2">库存修改</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item style="text-align: center;">
          <a-button type="primary" @click="saveProjectEvent">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ResourceControlList',
  data() {
    return {
      queryParams: {},
      columns: [
        {
          title: '项目ID',
          dataIndex: 'itemId'
        },
        {
          title: '项目名称',
          dataIndex: 'itemName'
        },
        {
          title: '被授权资源方',
          dataIndex: 'itemResourcesEmail'
        },
        {
          title: '授权权限',
          dataIndex: 'itemResourcesPurview',
          scopedSlots: { customRender: 'itemResourcesPurview' }
        },
        {
          title: '状态',
          dataIndex: 'itemStatus',
          scopedSlots: { customRender: 'itemStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      projectVisible: false,
      checkList: [],
      itemResourcesEmail: '',
      itemName: '',
      editProjectItem: undefined,
      businessInfo: undefined, //商户信息
      title: '添加项目'
    }
  },
  computed: {
    ...mapState({
      vesion: state => state.config.serverDataInfo.vesion
    })
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ResourceControlList', title: '项目列表' },
      { name: 'PushOrder', title: '推送订单' },
      { name: 'BatchOrder', title: '批量导单' },
      { name: 'CommodityList', title: '商品列表' }
    ])
    this.queryParams = {
      merchantId: this.merchantId,
      platformId: this.platformId
    }
  },
  mounted() {
  },
  methods: {
    addProject() {
      this.itemName = undefined
      this.itemResourcesEmail = undefined
      this.checkList = []
      this.getBusinessInfo()
      this.editProjectItem = null
      this.title = '添加项目'
      this.projectVisible = true
    },
    handleAddCancel() {
      this.projectVisible = false
    },
    //编辑项目
    editProjectEvent(record) {
      this.getBusinessInfo()
      this.title = '编辑项目'
      this.editProjectItem = record
      this.itemName = record.itemName
      this.itemResourcesEmail = record.itemResourcesEmail
      this.checkList = record.itemResourcesPurview.split(',')
      this.projectVisible = true
    },
    // 关联商品
    bindProductEvent(record) {
      this.$router.push({
        name: 'ResourceControlList_BindProduct',
        query: {
          projectId: record.itemId
        }
      })
    },
    //保存项目（创建、编辑）
    saveProjectEvent() {
      if (!this.itemName) {
        this.$message.error('项目名称不能为空')
        return
      }
      if (!this.itemResourcesEmail) {
        this.$message.error('被授权资源方不能为空')
        return
      }
      if (!this.checkList || this.checkList.length < 1) {
        this.$message.error('请选择授权权限')
        return
      }
      let item = this.editProjectItem ? this.editProjectItem : {}
      const params = {
        ...item,
        itemResourcesPurview: this.checkList.join(','),
        itemResourcesEmail: this.itemResourcesEmail,
        itemName: this.itemName,

        merchantId: this.merchantId,
        platformId: this.platformId,
        itemMerchantContact: this.businessInfo.merchantContact,
        itemMerchantName: this.businessInfo.merchantFullName,
        itemMerchantPhone: this.businessInfo.merchantMobile
      }
      this.getLogUtils().logWithTag(' ====params =====', params, '  this.businessInfo  ', this.businessInfo)
      this.addOrUpdateProject(params)
        .then(res => {
          const tips = this.editProjectItem ? '数据更新成功' : '商品添加成功'
          this.$message.success(tips)
          this.projectVisible = false
          this.editProjectItem = undefined
          this.$refs.tableList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //添加、编辑项目
    addOrUpdateProject(params) {
      return new Promise((resolve, reject) => {
        const url = 'item/addOrUpdate'
        this.getHttpServices()
          .getResourceService()
          .post(url, params)
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      })
    },
    //获取商户信息
    getBusinessInfo() {
      if (this.businessInfo) {
        return
      }
      this.getHttpServices()
        .getUserService()
        .get('user/merchantInfo/getMerchantInfoById?merchantId=' + this.merchantId)
        .then(res => {
          this.businessInfo = res
        })
        .catch(err => {
          this.getLogUtils().logWithTag('err', err)
        })
    },
    //: 被授权资源方权限 '' 无授权 1订单处理 2库存修改 多选时以逗号分隔 ,
    getResourcesPurviewStr(resourcesPurview) {
      let str = ''
      if (resourcesPurview) {
        let strings = resourcesPurview.split(',')
        strings.forEach((itemStr, index, arr) => {
          if (str.length > 0) {
            str = str + ','
          }
          if (itemStr == 1) {
            str = str + '订单处理'
          } else if (itemStr == 2) {
            str = str + '库存修改'
          } else {
            str = str + '无授权'
          }
        })
      }
      return str
    }
  }
}
</script>
<style scoped>
</style>